(() => {
  const closeId = 'atelier-chat-close';
  const backId = 'atelier-chat-back';
  const backStyleId = 'atelier-chat-back-label';

  const persistClosedState = () => {
    const key = 'shopifyChatData';

    try {
      const chatState = JSON.parse(localStorage.getItem(key) || '{}');
      chatState.isOpen = false;
      localStorage.setItem(key, JSON.stringify(chatState));
    } catch {}
  };

  const labelNativeBack = (chat) => {
    const root = chat.shadowRoot;

    if (!root || root.getElementById(backStyleId)) return;

    const style = document.createElement('style');
    style.id = backStyleId;
    style.textContent = `
      button[name="backButton"] {
        display: none !important;
      }

      button[name="closeChat"],
      .chat-app--close-button {
        display: none !important;
      }
    `;

    root.append(style);
  };

  const attachChatControls = () => {
    const chat = document.querySelector('#ShopifyChat');

    if (!chat || document.getElementById(closeId)) return Boolean(chat);

    const close = document.createElement('a');
    close.id = closeId;
    close.href = window.location.href;
    close.hidden = true;
    close.setAttribute('aria-label', 'Close chat');
    close.innerHTML = '<span aria-hidden="true">×</span>';

    const back = document.createElement('button');
    back.id = backId;
    back.type = 'button';
    back.hidden = true;
    back.innerHTML = '<span aria-hidden="true">←</span><span>Back to questions</span>';

    const positionBack = () => {
      const bounds = chat.getBoundingClientRect();
      back.style.left = `${Math.max(bounds.left + 16, 16)}px`;
      back.style.top = `${Math.max(bounds.top + 16, 16)}px`;
    };

    const sync = () => {
      const isOpen = chat.getAttribute('is-open') === 'true';
      const nativeBack = chat.shadowRoot?.querySelector('button[name="backButton"]');

      close.hidden = !isOpen;
      back.hidden = !isOpen || !nativeBack;
      positionBack();
      labelNativeBack(chat);
    };

    new MutationObserver(sync).observe(chat, { attributes: true, attributeFilter: ['is-open'] });
    new MutationObserver(sync).observe(chat.shadowRoot, { childList: true, subtree: true });
    window.addEventListener('resize', positionBack, { passive: true });
    back.addEventListener('click', () => {
      chat.shadowRoot?.querySelector('button[name="backButton"]')?.click();
      window.setTimeout(sync, 0);
    });
    document.body.append(close);
    document.body.append(back);
    sync();

    return true;
  };

  persistClosedState();

  if (!attachChatControls()) {
    new MutationObserver((_, observer) => {
      if (attachChatControls()) observer.disconnect();
    }).observe(document.documentElement, { childList: true, subtree: true });
  }
})();
